import * as React from 'react';
import MyMarker from '../../components/Marker';
import { ObjectCard } from '../../components/ObjectCard';
import LayersContext from '../../context/LayersContext';
import { Box } from '@mui/system';
import { titleCase } from 'title-case';

const endpoint = "assetaps";

// Name of the regular Signals layer (module.name in modules/Signal/index.js)
const SIGNAL_LAYER_NAME = 'Signals';

const showCardContent = (obj) => { return true }

const ModuleMarker = (props) => {
    const layersContext = React.useContext(LayersContext);
    // When the Signals layer is on, the signal image is already drawn, so use the
    // no-signal APS icon to avoid overlapping/duplicate signal images.
    const signalsLayerOn = layersContext[SIGNAL_LAYER_NAME]?.enabled === true;
    return (
        <MyMarker {...props} icondef={getIcon(signalsLayerOn)} />
    )
}

const getIcon = (signalsLayerOn) => {
    return {
        url: signalsLayerOn ? "/mapicons/signal/apsNoSignal.png" : "/mapicons/signal/aps.png",
        anchor: signalsLayerOn ? new window.google.maps.Point(-5, 9) : new window.google.maps.Point(6, 15),
        scaledSize: signalsLayerOn ? new window.google.maps.Size(35, 35) : new window.google.maps.Size(44, 44)
    };
}

const CardContent = (props) => {
    const obj = props.obj;
    return (
        <>
            <Location value={obj} />
            {/* <AbsoluteAddress value={obj} /> */}
        </>
    )
}

const AbsoluteAddress = props => {
    const obj = props.value;
    var absAddress = "";
    if(obj.nsAddress) {
        absAddress += obj.nsAddress;
    }
    if(obj.ewAddress) {
        if(absAddress !== "") {
            absAddress += " / "
        }
        absAddress += obj.ewAddress;
    }
    return (
        <Box>{absAddress}</Box>
    )
}

const Location = props => {
    const obj = props.value;
    if(obj.name) {
        return (
            <Box sx={{ fontWeight: 'bold'}}>{titleCase(obj.name.toLowerCase())}</Box>
        )
    } else {
        return null;
    }
}

const InfoWindow = (props) => {
    const module = props.module;
    const obj = props.icon;
    const MyCardContent = module.cardContent;
    const showCardContent = module.showCardContent;

    return (
        <div className="infoWindow center"><div>Accessible Pedestrian Signal</div>
            {showCardContent(obj) ?
                <div className="spacer"><MyCardContent obj={obj} /></div>
                :
                null}
        </div>
    )
}

export default {
    name: 'APS',
    label: 'Accessible Pedestrian Signals',
    marker: ModuleMarker,
    showOnMap: true, //show on map layer filter
    mapLayerIcon: "/mapicons/signal/aps.png",
    mapLayerIconSize: 42, 
    showOnSidebar: false,
    sideBarCard: ObjectCard,
    endpoint: endpoint,
    defaultOn: false,
    updateDelay: 60,
    showCardContent: showCardContent,
    cardContent: CardContent,
    infoWindow: InfoWindow,
    popupOnHover: true, //open info window on mouse hover in addition to click
    announceLayerButtonOnHover: true, //screen reader announces the layer filter button on hover
    cluster: false,
    clusterMarker: "/mapicons/signal/signal",
    clusterClass: "signal-cluster",
    publishLayer: "tasWebapp.aps.enable"
}
